export const PROJECTS_CORE = 'PROJECTS_CORE';
export const USERS = 'USERS';
export const AUDIENCES_SERVICE = 'AUDIENCES_SERVICE';
export const SURVEY_SERVICE = 'SURVEY_SERVICE';
